// © 2015-2021 WDNA - All Rights Reserved

import EmptyPage from './loaders/Error404';

export const redirects: any[] = [
  {
    from: '/404',
    to: '/404/main',
  },
];

export const routes: any[] = [
  {
    component: EmptyPage,
    path: '/404/main',
  },
];
